<template>
  <v-container>
    <avs-backButton
      v-if="!inDialog"
      backTo="StaffMembers"
    />
    <AvsSteppers
      :value="tab"
      @change="v => (tab = v)"
    >
      <template v-slot:headers>
        <AvsStep
          step="1"
          :rules="[() => isFormValid.informations]"
        >
          {{ $t("commons.informations") }}
          <small v-show="!isFormValid.informations">{{ $t("commons.validation_issues") }}</small>
        </AvsStep>
      </template>
      <template v-slot:items>
        <v-stepper-content step="1">
          <v-form
            ref="form-informations"
            v-model="isFormValid.informations"
            class="pt-2 mb-5"
            lazy-validation
          >
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="staff.last_name"
                :rules="isDisable ? [] : rules.last_name"
                :disabled="isDisable"
                auto-grow
                clearable
                dense
                outlined
                :label="$t('commons.last_name')"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="staff.first_name"
                :rules="isDisable ? [] : rules.first_name"
                :disabled="isDisable"
                auto-grow
                clearable
                dense
                outlined
                :label="$t('commons.first_name')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="staff.matricule"
                :rules="isDisable ? [] : rules.matricule"
                :disabled="isDisable"
                auto-grow
                clearable
                dense
                outlined
                :label="$t('Matricule')"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="staff.department"
                :disabled="isDisable"
                :items="departments"
                :rules="rules.departments"
                item-text="name"
                item-value="id"
                :label="$t('Departement')"
                attach
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="staff.email"
                :rules="isDisable ? [] : rules.email"
                :disabled="isDisable || staffExists"
                auto-grow
                clearable
                dense
                outlined
                :label="$t('commons.email')"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="staff.phone_number"
                :rules="rules.phone_number"
                :disabled="isDisable || staffExists"
                auto-grow
                clearable
                dense
                outlined
                :label="$t('N° Téléphone conducteur')"
                @input="enforcePhoneFormat"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="staff.position"
                :rules="isDisable ? [] : rules.position"
                :disabled="isDisable"
                auto-grow
                clearable
                dense
                outlined
                :label="$t('Poste Occupé')"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="staff.location_shop"
                :disabled="isDisable"
                :items="shops"
                :rules="rules.shops"
                item-text="name"
                item-value="id"
                :label="$t('Site')"
                attach
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
            <v-col class="col-12 pb-0 mb-0">
              <div>
                <h3>{{ $t("Est-il un utilisateur web ?") }}</h3>
                <p>Un utilisateur web est une personne qui accède à votre espace web afin d'effectuer diverses actions. Il peut s'agir, par exemple, d'un membre de votre société.</p>
              </div>
              <v-switch
                inset
                color="success"
                :disabled="isDisable || staffExists"
                v-model="staff.is_webuser"
                :label="staff.is_webuser ? 'Active' : 'Inactive'"
                 @change="toggleSwitch('webuser')"
              ></v-switch>
            </v-col>

            <v-col class="col-12 pb-0 mb-0" v-if="$store.getters['app/getCompany'].company_type == 'Business'">
              <div>
                <h3>{{ $t("Est-il un utilisateur Pro ? ") }}</h3>
                <p>Un utilisateur professionnel est une personne habilitée à scanner les QR codes des clients pour effectuer des paiements.</p>
              </div>
              <v-switch
                inset
                color="success"
                v-model="staff.is_pro_mobile"
                :label="staff.is_pro_mobile ? 'Active' : 'Inactive'"
                 @change="toggleSwitch('pro')"
              ></v-switch>
            </v-col>


          </v-form>
        </v-stepper-content>

      </template>
      <v-spacer></v-spacer>
      <template v-slot:actions>
        <v-card-actions class="mr-4 justify-end">
          <avs-saveButton
            :loading="loading"
            @click="save"
          />
        </v-card-actions>
      </template>
    </AvsSteppers>

    <avs-CloseDialog
      v-model="closeDialogIsOpen"
      @cancel="handleCancel"
      @confirm="handleConfirm"
    />
    <v-progress-linear
      :active="loading"
      indeterminate
      absolute
      top
    ></v-progress-linear>

    <!-- Overlay qui grise l'écran avec un spinner -->
    <v-overlay
      v-model="loading"
      absolute
      opacity="0.25"
    >
      <div class="text-center">
        <v-progress-circular indeterminate size="56" width="6"></v-progress-circular>
        <div class="mt-3 font-weight-medium">Chargement…</div>
      </div>
    </v-overlay>
  </v-container>
</template>

<script>
import _ from "lodash"
const noop = () => undefined
import { StaffMembersService, ShopDetailService, DepartmentService } from "@/services"
import { mkStaffMember } from "@/utils/datamodels"


// import {
//   // DateInput,
//   StaffPictures
// } from "@/components"
import { required, phone } from "@/utils/validator"

export default {
  name: "StaffCreateUpdate",
  components: {
    AvsStep: () => import("@/components/generics/general/AvsStep.vue"),
    AvsSteppers: () => import("@/components/generics/general/AvsSteppers.vue"),
    // StaffPictures,
    // DateInput,
  },
  props: {
    inDialog: {
      type: Boolean,
      default: false
    },
    inDialogParams: {
      type: Object,
      default: () => {}
    }
  },
  data: function () {
    return {
      staffRef: null,
      staff: mkStaffMember(),
      tab: this.$route.params.tab ? this.$route.params.tab : 1,
      nextLabel: this.$t("commons.next"),
      loading: false,
      step: -1,
      minReportDate: null,
      shops: [],
      departments: [],
      rules: {
        last_name: [required],
        first_name: [required],
        email: [required],
        phone_number: [required, phone],
        position: [],
        company: [],
        monthly_limit: [],
        current_spending: [],
        shops: [],
        departments: [],
        matricule:[required]
      },
      isFormValid: {
        informations: false,
        budgeet: false,
        causeAndResolution: false
      },
      validateRequest: {
        budgeet: 0
      },                      
      isDisable: false,
      isClosed: false,
      closeDialogIsOpen: false,
      users: [],
    }
  },
  created() {
    this.fetchStaff()
    this.fetchFieldTypes()
    this.fetchDepartmentTypes()
  },
  methods: {
    enforcePhoneFormat() {
      if (!this.staff.phone_number) return
      if (!this.staff.phone_number.startsWith("+225")) {
        this.staff.phone_number = "+225" + this.staff.phone_number.replace(/^(\+225)?/, "")
      }
    },
    fetchDepartmentTypes() {
      DepartmentService.getDepartment(this.company.pk).then(response => {
        this.departments = response
      })
    },
    toggleSwitch(type) {
      if (type === 'webuser' && this.staff.is_webuser) {
        this.staff.is_pro_mobile = false; // Désactiver "Pro" si "Web" est activé
      } else if (type === 'pro' && this.staff.is_pro_mobile) {
        this.staff.is_webuser = false; // Désactiver "Web" si "Pro" est activé
      }
    },
    save() {
      this.$refs["form-informations"].validate()
      this.$nextTick(() => {
        if (this.isFormValid.informations)
          if (this.staffExists) {
            this.updateStaff()
          } else {
            this.createStaff()
          }
        else {
          this.tab = 1
          const message = this.$t("messages.warning.all_required_info")
          this.send(message, "warning")
        }
      })
    },
    tabIncrement() {
      return this.tab < 4 ? this.tab++ : this.$router.push({ name: "StaffMembers" })
    },
    handleClose() {
      return this.$router.push({ name: "StaffMembers" })
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    },
    getStaff(id) {
      if (id) {
        let t = this
        StaffMembersService.get(this, id).then(r => {
          t.staff = r
          t.staffRef = _.cloneDeep(t.staff)
        })
      }
    },
    createStaff() {
      let tmp = _.cloneDeep(this.staff)
      // alert("okok")
      // alert(tmp.is_webuser)
      // console.log(tmp.is_webuser)

      this.loading = true
      StaffMembersService.create(this,  tmp)
        .then(response => {
          this.staff = response
          this.staffRef = _.cloneDeep(response)
          this.send(
            this.$t("messages.success.saved", {
              entity: this.$tc("categories.staff.name", 1)
            }),
            "success"
          )
          this.$router.push({ name: "StaffMembers" })
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          } else {
            let message = ""
            for (const e in err.response.data) {
              message += "- " + e + " : " + err.response.data[e] + "\n"
            }
            this.$store.commit("app/message", {
              msg: message,
              color: "error"
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateStaff() {
      const requests = []
      //  Delete pictures (has deleted==true)

      if (!_.isEqual(_.omit(this.staff), _.omit(this.staffRef))) {
        requests.push(StaffMembersService.update(this, this.staff.id, _.omit(this.staff)))
      }
      if (requests.length > 0) {
        this.loading = true
        Promise.all(requests)
          .then(() => {
            this.send(
              this.$t("messages.success.updated", {
                entity: this.$tc("categories.staff.name", 1)
              }),
              "success"
            )
            this.$router.push({ name: "StaffMembers" })
          })
          .catch(err => {
            let message = ""
            for (const e in err.response.data) {
              message += "- " + e + " : " + err.response.data[e] + "\n"
            }
            this.send(message, "error")
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.send(this.$t("messages.success.no_updated"), "info")
      }
    },
    fetchStaff() {
      // Load Staff
      this.getStaff(this.id)
    },
    fetchFieldTypes() {
      ShopDetailService.getAll(this).then(response => {
        this.shops = response
      })
    },
    handleError(msg) {
      // Handle message display
      this.$store.commit("app/message", { msg, color: "error" })
    },
    handleSign() {
      // Handle message display
      this.isDisable = true
    },
    handleSuccess(isSaved, nextTab, postProcess = noop, message = null) {
      // Handle message display
      const msg_success = message ? message : this.$t("messages.success.operation")
      const data = isSaved
        ? { msg: msg_success, color: "success" }
        : { msg: this.$t("messages.success.no_updated"), color: "info" }
      this.$store.commit("app/message", data)

      // Handle next display
      this.tab = nextTab

      // Postprocess
      postProcess()
    },
    handleConfirm() {
      StaffMembersService.close(this, this.staff.id)
        .then(r => {
          this.$store.commit("app/message", {
            msg: this.$t("messages.success.closed", {
              entity: this.$tc("categories.staff.name", 1)
            }),
            color: "success"
          })
          this.closeDialogIsOpen = false
          this.isClosed = true
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
      this.closeDialogIsOpen = false
    },
    handleCancel() {
      this.closeDialogIsOpen = false
    }
  },
  watch: {
    tab(newValue, oldValue) {
      if (oldValue === 1) {
        this.save()
      } 
    }
  },
  computed: {
    id() {
      return this.inDialog ? this.inDialogParams?.id : this.$route.params.id || null
    },
    staffExists() {
      return !!this.staff.id
    },
    company() {
      return this.$store.state.app.company
    },
    projectId() {
      return this.$store.state.app.project.id
    },
    projectRole() {
      return this.$store.state.app.project.role
    }
  }
}
</script>

<style lang="scss">
.custom-container {
  display: flex;
  flex-direction: column;
  height: 80vh;
}
.stepper-item {
  flex: 1 1 auto;
  overflow-y: auto;
}
.ck.ck-editor__main > .ck-editor__editable {
  height: 130px;
}
.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by {
  display: none !important;
}
.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.ck-editor__editable {
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>
